exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".tips[data-v-1ea78f0b]{position:fixed !important;position:absolute;left:50%;transform:translate(-50%, 0);top:70px;font-size:30px;z-index:2001;color:#f74e57;text-shadow:2px 2px rgba(0,0,0,0.05);cursor:pointer}\n", ""]);

